import {usePixiRenderContext} from '@glark-newco/game-library';
import {Ticker} from 'pixi.js';
import {useEffect, useRef} from 'react';

interface AnimationProps {
    animation: (progress: number) => void
    animationTimeMs: number
    check?: () => boolean
    initialisation?: () => void
    cleanup?: () => void
}

/*
Note - duplicated in Signlines.  Potentially extract to Game Library, but deferring for now until we review the API.
 */
export function useAnimation<Type>({animation, animationTimeMs, check, initialisation, cleanup}: AnimationProps, dependencies: Type[]) {
    const {triggerRender} = usePixiRenderContext();
    const startTimeRef = useRef<number>(0);

    useEffect(() => {
        startTimeRef.current = performance.now();
        const ticker = new Ticker();

        // Sanity checks (if there are any)
        if (check?.()) { return; } // Is check failing

        initialisation?.();
        
        const animate = () => {
            const now = performance.now();
            const elapsed = now - startTimeRef.current;
            const progress = Math.min(elapsed / animationTimeMs, 1);

            // most important callback, animation code
            animation(progress);
            triggerRender(); // triggers render once per animation-frame

            if (progress >= 1) { // If animation has finished
                cleanup?.();
                ticker.stop();
            }
        };

        ticker.add(animate);
        ticker.start();

        return () => {
            ticker.stop();
            ticker.remove(animate);
        };
    }, dependencies);
}
